// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"d6203914","735":"696c7a95"}[chunkId] + ".chunk.js";
};